import React from 'react';
import PropTypes from 'prop-types';
import Loader from './Loader';

const SectionLoader = (props) => {
	const {className, wrapperClassName, iClassName} = props;

	return (
		<section className={className}>
			<div className="box">
				<Loader wrapperClassName={wrapperClassName} iClassName={iClassName} />
			</div>
		</section>
	);
};

SectionLoader.defaultProps = {
	className: 'content',
	wrapperClassName: 'overlay',
	iClassName: 'fa fa-refresh fa-spin'
};

SectionLoader.propTypes = {
	className: PropTypes.string,
	wrapperClassName: PropTypes.string,
	iClassName: PropTypes.string
};

export default SectionLoader;